export const isPersistedDatastreamId = (value) => {
  const parsed = Number(value);
  return Number.isInteger(parsed) && parsed > 0;
};

export const getNextTemporaryDatastreamId = (list = []) => {
  const ids = (Array.isArray(list) ? list : [])
    .filter(Boolean)
    .map((datastream) => Number(datastream?.id))
    .filter(Number.isFinite);

  const minId = ids.length > 0 ? Math.min(...ids) : 0;
  return minId <= 0 ? minId - 1 : -1;
};

export const formatDatastreamIdForDisplay = (value) =>
  isPersistedDatastreamId(value) ? Number(value) : "Auto";
